import {Component, OnInit, ViewChild} from '@angular/core';
import {Document} from '../../../model/Document';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DocumentService} from '../../../service/document.service';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../service/auth/auth.service';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.css']
})
export class DocumentPreviewComponent implements OnInit {
  public loading: boolean;
  public document: Document;
  public documents: Document [];
  public reviewForm: FormGroup;
  public urlStream;
  public personId;
  public resourceList: any[] = [];
  public title = 'TITLE.DOCUMENT-PREVIEW';
  public reloadingPdf = false;
  @ViewChild('pdfViewer') pdfViewer;

  constructor(private activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private documentService: DocumentService,
              private applicationService: ApplicationService,
              private router: Router,
              private authenticationService: AuthService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit(): void {
    this.document = this.documents[0];
    this.reloadResourceList();
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
        this.activeModal.close(InformType.Anything);
      }
    }, 300);
  }

  private buildUrlSource() {
    this.urlStream = this.document._more.resources[0].url;
  }

  public isInvalidControl(ctrlName: string) {
    return this.reviewForm.get(ctrlName).invalid && this.reviewForm.get(ctrlName).touched;
  }

  public cancel(): void {
    this.activeModal.close(InformType.Anything);
  }

  public setUrlDoc(resource: any) {
    this.urlStream = resource.url;
    this.reloadPdfViewer();
  }

  private reloadPdfViewer(): void {
    this.reloadingPdf = true;
    const interval = setTimeout(() => {
      this.reloadingPdf = false;
    }, 300);
  }

  public reloadResourceList() {
    this.resourceList = this.document._more.resources;
    this.setUrlDoc(this.resourceList[0]);
    this.buildUrlSource();
  }
}
